import i18n from '@/helpers/i18n'
import { REGION_FILTERS } from '@/helpers/region-labels'

export default {
  initialiseFilters: function(gatherings, businesses) {
    const categories = this.getCategories()
    const regions = REGION_FILTERS
    const filters = {}
    filters.name = ''
    filters.showGatherings = true
    filters.showBusinesses = true
    filters.categories = {}
    filters.regions = {}
    filters.cities = {}
    
    gatherings.map(gathering => {
      const regionId = this.getStringId(regions, gathering.region)
      const translatedRegion = this.getTranslation(regions, gathering.region)
      const cityId = regionId + gathering.city
      if (!filters.regions[regionId]) {
        filters.cities[cityId] = this.createCity(cityId, regionId, gathering.city, new Set([gathering.id]), new Set([]))
        filters.regions[regionId] = this.createRegion(regionId, translatedRegion, new Set([gathering.id]), new Set([]))
      } else {
        filters.regions[regionId].gatheringIds.add(gathering.id)
        if (!filters.cities[cityId]) {
          filters.cities[cityId] = this.createCity(cityId, regionId, gathering.city, new Set([gathering.id]), new Set([]))
        } else {
          filters.cities[cityId].gatheringIds.add(gathering.id)
        }
      }

      gathering.businessesData.forEach(business => {
        filters.cities[cityId].businessIds.add(business.id)
        filters.regions[regionId].businessIds.add(business.id)
      })
    })

    businesses.map(business => {
      const categoryId = this.getStringId(categories, business.entreprise_category_id)
      const translatedCategory = this.getTranslation(categories, business.entreprise_category_id)
      if (!filters.categories[categoryId]) {
        filters.categories[categoryId] = this.createCategory(categoryId, translatedCategory, new Set([]), new Set([business.id]))
      } else {
        filters.categories[categoryId].businessIds.add(business.id)
      }

      // If not in gathering
      if (business.region > 0) {
        const regionId = this.getStringId(regions, business.region)
        const translatedRegion = this.getTranslation(regions, business.region)
        const cityId = regionId + business.city
        if (!filters.regions[regionId]) {
          filters.cities[cityId] = this.createCity(cityId, regionId, business.city, new Set([]), new Set([business.id]))
          filters.regions[regionId] = this.createRegion(regionId, translatedRegion, new Set([]), new Set([business.id]))
        } else {
          filters.regions[regionId].businessIds.add(business.id)
          if (!filters.cities[cityId]) {
            filters.cities[cityId] = this.createCity(cityId, regionId, business.city, new Set([]), new Set([business.id]))
          } else {
            filters.cities[cityId].businessIds.add(business.id)
          }
        }
      }
    })

    return filters
  },
  createCategory: function(id, name, gatheringIds, businessIds) {
    return { id: id, name: name, gatheringIds: gatheringIds, businessIds: businessIds, checked: false }
  },
  createCity: function(id, regionId, name, gatheringIds, businessIds) {
    return { id: id, regionId: regionId, name: name, gatheringIds: gatheringIds, businessIds: businessIds, checked: false }
  },
  createRegion: function(id, name, gatheringIds, businessIds) {
    return { id: id, name: name, gatheringIds: gatheringIds, businessIds: businessIds, checked: false }
  },
  getCategories: function() {
    return [
      { id: 1, text: 'business-category-foodeat' },
      { id: 2, text: 'business-category-fooddrink' },
      { id: 3, text: 'business-category-foodothers' },
      { id: 4, text: 'business-category-productsclothes' },
      { id: 5, text: 'business-category-productsaccessories' },
      { id: 6, text: 'business-category-productsdecorations' },
      { id: 7, text: 'business-category-productsentertainment' },
      { id: 8, text: 'business-category-productsothers' },
      { id: 9, text: 'business-category-servicesentertainmentleisure' },
      { id: 10, text: 'business-category-servicesmaintenance' },
      { id: 11, text: 'business-category-servicescare' },
      { id: 12, text: 'business-category-servicesothers' },
      { id: 13, text: 'business-category-artsperformance' },
      { id: 14, text: 'business-category-artsartwork' },
      { id: 15, text: 'business-category-artsothers' }
    ]
  },
  getStringId(translations, id) {
    var translation = translations.find(x => x.id === id)
    return translation ? translation.text : ""
  },
  getTranslation: function(translations, id) {
    var translation = translations.find(x => x.id === id)
    return translation ? i18n.instance().t(translation.text) : ""
  },
  getFilteredGatheringsBusinesses: function(filters) {
    const categoriesResults = this.getFilteredGatheringsBusinessesForFilterType(filters.categories)
    const regionsResults = this.getFilteredGatheringsBusinessesForFilterType(filters.regions)
    const citiesResults = this.getFilteredGatheringsBusinessesForFilterType(filters.cities)
    return { 
      gatheringIds: new Set([...categoriesResults.gatheringIds, ...regionsResults.gatheringIds, ...citiesResults.gatheringIds]), 
      businessIds: new Set([...categoriesResults.businessIds, ...regionsResults.businessIds, ...citiesResults.businessIds]),
      hasFilterApplied: categoriesResults.hasFilterApplied || regionsResults.hasFilterApplied || citiesResults.hasFilterApplied,
      showGatherings: filters.showGatherings,
      showBusinesses: filters.showBusinesses
    }
  },
  getFilteredGatheringsBusinessesForFilterType: function(filters) {
    const gatheringIds = new Set([])
    const businessIds = new Set([])
    let hasFilterApplied = false

    for (let filter in filters) {
      if(filters[filter].checked) {
        hasFilterApplied = true
        filters[filter].gatheringIds.forEach(x => gatheringIds.add(x))
        filters[filter].businessIds.forEach(x => businessIds.add(x))
      }
    }

    return { gatheringIds: gatheringIds, businessIds: businessIds, hasFilterApplied: hasFilterApplied }
  }
}
